import { computed, ref } from "vue";
export function useAddressesWidget(addresses, callbacks) {
    const primaryAddressId = computed(() => addresses.value.find((a) => a.isPrimary)?.id ?? "");
    const showAddressesModal = ref(false);
    const showAddressFormModal = ref(false);
    const editingAddress = ref(null);
    const showDeleteAddressModal = ref(false);
    const pendingDeleteAddress = ref(null);
    const setPrimaryAddress = async (id) => {
        await callbacks.onSetPrimary(id);
    };
    const openAddAddress = () => {
        editingAddress.value = null;
        showAddressFormModal.value = true;
    };
    const openEditAddress = (address) => {
        editingAddress.value = { ...address };
        showAddressFormModal.value = true;
    };
    const saveAddress = async (address) => {
        const isExisting = addresses.value.some((a) => a.id === address.id);
        if (isExisting) {
            await callbacks.onEdit(address);
        }
        else {
            await callbacks.onAdd(address);
        }
    };
    const deleteAddress = (address) => {
        pendingDeleteAddress.value = address;
        showDeleteAddressModal.value = true;
    };
    const confirmDeleteAddress = async () => {
        const address = pendingDeleteAddress.value;
        if (!address)
            return;
        await callbacks.onDelete(address.id);
        showDeleteAddressModal.value = false;
        pendingDeleteAddress.value = null;
    };
    const cancelDeleteAddress = () => {
        showDeleteAddressModal.value = false;
        pendingDeleteAddress.value = null;
    };
    return {
        primaryAddressId,
        showAddressesModal,
        showAddressFormModal,
        editingAddress,
        showDeleteAddressModal,
        pendingDeleteAddress,
        setPrimaryAddress,
        openAddAddress,
        openEditAddress,
        saveAddress,
        deleteAddress,
        confirmDeleteAddress,
        cancelDeleteAddress,
    };
}
